import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "in-out-checkbox" }
const _hoisted_2 = ["disabled"]

import { ref } from 'vue';
	import axios from 'axios';
	import functions from '@/use/functions';
	import { Permissions, PermissionLevels } from '@/models/permissions';
	import PermissionsWrapper from '@/components/wrappers/PermissionsWrapper.vue';
	import { DisbursementBatchReferenceModel, DisbursementDetailsModel } from '../../models/disbursementBatchesV2';

	
export default /*@__PURE__*/_defineComponent({
  __name: 'BatchDisbursementRow',
  props: {
    batchId: {},
    reference: {},
    disbursement: {},
    isBatchApproved: { type: Boolean },
    isProcessing: { type: Boolean },
    onBatchUpdateAsync: { type: Function }
  },
  setup(__props: any) {

	const props = __props;

	const isIn = ref(!props.reference.isDeleted);
	const isToggling = ref(false);

	const toggleAddRemoveAsync = async () => {
		if (props.isBatchApproved || props.isProcessing || isToggling.value) {
			return;
		}

		isToggling.value = true;

		try {
			await updateReferenceAsync(isIn.value ? 'add' : 'remove');
		} catch (error) {
			console.error(error);
		} finally {
			isToggling.value = false;
		}
	};

	const updateReferenceAsync = async (action: 'add' | 'remove') => {
		try {
			const url = `/api/v2/disbursement-batches/${props.batchId}/disbursement/${props.reference.disbursementId}`;

			if (action === 'add') {
				await axios.post(url);
			} else if (action === 'remove') {
				await axios.delete(url);
			}
			
			await props.onBatchUpdateAsync();
		} catch (error) {
			console.error(error);

			functions.openModal({
				title: 'Oops!',
				description: `Failed to ${action} the disbursement ${action === 'add' ? 'to' : 'from'} the batch.`
			});

			isIn.value = !isIn.value; // reset
		}
	};

	const onRowClick = (event: MouseEvent) => {
		const target = event.target as HTMLElement;
		
		if (target.closest("#in-out-checkbox")) {
    		return;
  		}

		window.open(`/certifications/${props.disbursement?.certificationId}`, "_blank");
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", {
    class: "clickable-row",
    onClick: onRowClick
  }, [
    _createElementVNode("td", _hoisted_1, [
      _createVNode(PermissionsWrapper, {
        showDisabledIfNotVisible: true,
        permissionIds: [_unref(Permissions).DisbursementBatches],
        permissionLevel: _unref(PermissionLevels).Update
      }, {
        default: _withCtx(() => [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isIn).value = $event)),
              disabled: __props.isBatchApproved || __props.isProcessing || isToggling.value,
              onChange: toggleAddRemoveAsync
            }, null, 40, _hoisted_2), [
              [_vModelCheckbox, isIn.value]
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "custom-checkbox" }, null, -1))
          ])
        ]),
        _: 1
      }, 8, ["permissionIds", "permissionLevel"])
    ]),
    _createElementVNode("td", null, _toDisplayString(__props.disbursement?.lenderName), 1),
    _createElementVNode("td", null, _toDisplayString(__props.disbursement?.borrowerName), 1),
    _createElementVNode("td", null, _toDisplayString(__props.disbursement?.disbursementAmountFormatted), 1),
    _createElementVNode("td", null, _toDisplayString(__props.disbursement?.disbursementMethodHumanized), 1),
    _createElementVNode("td", null, _toDisplayString(__props.disbursement?.disbursementDateFormatted), 1),
    _createElementVNode("td", null, _toDisplayString(__props.disbursement?.referenceId), 1),
    _createElementVNode("td", null, _toDisplayString(__props.disbursement?.lenderUseOnly), 1),
    _createElementVNode("td", null, _toDisplayString(__props.disbursement?.sequenceNumber), 1)
  ]))
}
}

})